

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.6 } }
};

export const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

export const fadeInDown = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

export const fadeInLeft = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

export const fadeInRight = {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

export const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
};

export const scaleUp = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.6 }
    }
};

export const morphBlob = {
    animate: {
        borderRadius: ['40% 60% 70% 30% / 40% 50% 60% 50%', '60% 40% 30% 70% / 60% 30% 70% 40%'],
        transition: {
            duration: 15,
            repeat: Infinity,
            repeatType: "reverse",
        }
    }
};

export const float = {
    animate: {
        y: [-15, 0, -15],
        transition: {
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};

export const notification1 = {
    animate: {
        y: [-20, 0, -20],
        rotate: [-2, 1, -2],
        transition: {
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};

export const notification2 = {
    animate: {
        y: [-15, 0, -15],
        rotate: [2, -1, 2],
        transition: {
            duration: 6,
            delay: 1,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};

export const notification3 = {
    animate: {
        y: [-25, 0, -25],
        rotate: [0, 2, 0],
        transition: {
            duration: 6,
            delay: 2,
            repeat: Infinity,
            ease: "easeInOut"
        }
    }
};